import React from 'react';

const TerminatedPlanWarning = ({ terminationYear, latestActiveYear, planStatus }) => {
  if (planStatus === 'TERMINATED') {
    return (
      <div className="mb-6 bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-coral rounded-2xl p-8 shadow-soft">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg 
              className="h-8 w-8 text-coral" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
              />
            </svg>
          </div>
          <div className="ml-4 flex-1">
            <h3 className="text-xl font-bold text-red-900 mb-3">
              ⚠️ Plan Terminated in {terminationYear}
            </h3>
            <div className="mt-2 text-red-800">
              <p className="text-sm leading-relaxed">
                This plan was closed and no longer exists. The analysis below is based on 
                data from {latestActiveYear} (before termination) and is for <strong>historical 
                reference only</strong>. This plan no longer accepts contributions or maintains 
                active accounts.
              </p>
            </div>
            <div className="mt-4 flex items-center text-sm text-red-700 bg-red-100 rounded-xl px-4 py-2 inline-flex">
              <svg 
                className="h-5 w-5 mr-2" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
              <span className="font-medium">
                Status: TERMINATED • Last Active: {latestActiveYear}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  if (planStatus === 'INACTIVE') {
    return (
      <div className="mb-6 bg-gradient-to-r from-yellow-50 to-amber-50 border-l-4 border-yellow-500 rounded-2xl p-8 shadow-soft">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg 
              className="h-8 w-8 text-yellow-600" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
              />
            </svg>
          </div>
          <div className="ml-4 flex-1">
            <h3 className="text-xl font-bold text-yellow-900 mb-3">
              ℹ️ No Recent Filings
            </h3>
            <div className="mt-2 text-yellow-800">
              <p className="text-sm leading-relaxed">
                This plan hasn't filed a Form 5500 since {latestActiveYear}. It may be 
                terminated or the employer may be behind on filings. The analysis shown 
                reflects data through {latestActiveYear}.
              </p>
            </div>
            <div className="mt-4 flex items-center text-sm text-yellow-700 bg-yellow-100 rounded-xl px-4 py-2 inline-flex">
              <svg 
                className="h-5 w-5 mr-2" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
              <span className="font-medium">
                Status: INACTIVE • Last Filing: {latestActiveYear}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  // Active plans don't show a warning
  return null;
};

export default TerminatedPlanWarning;
